import { Tooltip } from "antd";
import dayjs from "dayjs";
import CommonFooter from "../../../../../../core/common/footer/commonFooter";

import { Link, useParams } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import Table from "../../../../../../core/pagination/datatable";
const EstimatesTab = () => {
  const renderText = (text) => {
    if (!text || text.length === 0) return "N/A";

    return text.length > 10 ? (
      <Tooltip title={text}>
        <span>{text.substring(0, 10)}...</span>
      </Tooltip>
    ) : (
      text
    );
  };

  const [estimatesStatusOptions, setEstimatesStatusOptions] = useState([]);

  const getEstimatesStatuses = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}estimates/GetEstimatesStatus`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setEstimatesStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const columns = [
    {
      title: "Estimate #",
      dataIndex: "estimate",

      render: (_, record) => {
        return (
          <Link to={`/crm/view/estimate`} state={{ record }}>
            <span className={``}>
              <i className="fa-regular fa-file-lines me-2"></i>
              {record.estimate}
            </span>
          </Link>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "amount",
      align: "right",
      sorter: (a, b) => a.amount - b.amount,
      render: (amount) => (
        <span className="fw-semibold text-success">
          <i className="fa-solid fa-indian-rupee-sign me-1"></i>
          {Number(amount).toLocaleString("en-IN")}
        </span>
      ),
    },

    {
      title: "Tax",
      dataIndex: "tax",
      align: "right",
      sorter: (a, b) => a.tax - b.tax,
      render: (tax) => (
        <span className="">
          {/* <i className="fa-solid fa-percent me-1"></i> */}₹
          {Number(tax).toLocaleString("en-IN")}
        </span>
      ),
    },

    {
      title: "Date",
      dataIndex: "estimateDate",
      sorter: (a, b) =>
        dayjs(a.estimateDate).valueOf() - dayjs(b.estimateDate).valueOf(),
      render: (estimateDate) => (
        <>{estimateDate ? dayjs(estimateDate).format("DD-MM-YYYY") : "-"}</>
      ),
    },

    {
      title: "Ex-Date",
      dataIndex: "expiryDate",
      sorter: (a, b) =>
        dayjs(a.expiryDate).valueOf() - dayjs(b.expiryDate).valueOf(),
      render: (date) => (
        <>
          <span className="text-danger">
            {date ? dayjs(date).format("DD-MM-YYYY") : "-"}
          </span>
        </>
      ),
    },

    {
      title: "Reference",
      dataIndex: "referenceNo",
      sorter: (a, b) =>
        (a.referenceNo || "").localeCompare(b.referenceNo || ""),
      render: renderText,
    },

    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#6c757d";
            case "Sent":
              return "#0d6efd";

            case "Expired":
              return "#ffc107";
            case "Declined":
              return "#dc3545";
            case "Accepted":
              return "#198754";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              estimatesStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 100 }}
            options={estimatesStatusOptions}
            onChange={(value) => {
              updateEstimatesStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = estimatesStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          {/* <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v btn border" />
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to={`/crm/view/estimate`}
                state={{ record }}
                className="dropdown-item"
              >
                <Eye className=" me-2 info-img text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                to={`/crm/update/estimate/${record.id}`}
                className="dropdown-item"
                state={{
                  Id: record.id,
                  record,
                  type: "customer",
                }}
              >
                <Edit className="me-2 text-secondary" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                title="Edit"
                to={`/crm/update/estimate/${record.id}`}
                 state={{
                  Id: record.id,
                  record,
                  type: "customer",
                }}
                className="text-primary me-2 p-2"
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const { id } = useParams();

  const [customerData, setCustomerData] = useState({});

  const getCustomerDetails = async () => {
    try {
      // setCustomerLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${id}`,
      );

      if (response.data.Status) {
        setCustomerData(response.data.ResultData?.[0] || {});
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Unable to fetch customer details.",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (id) {
      getCustomerDetails();
    }
  }, [id]);

  const [estimateCounts, setEstimateCounts] = useState({
    TotalEstimates: 0,
    DraftEstimates: 0,
    SentEstimates: 0,
    ExpiredEstimates: 0,
    DeclinedEstimates: 0,
    AcceptedEstimates: 0,
  });

  const [estimates, setEstimates] = useState([]);
  console.log(estimates, "estimatessssssssssss");
  const [selectedStatus, setSelectedStatus] = useState(0);
  // const [countLoading, setCountLoading] = useState(false);
  const [estimateLoading, setEstimateLoading] = useState(false);

  const fetchEstimateCounts = async () => {
    try {
      // setCountLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}customers/GetCustomerEstimateCounts/${id}`,
      );

      if (response.data?.Status && response.data?.ResultData?.length > 0) {
        setEstimateCounts(response.data.ResultData[0]);
      }
    } catch (error) {
      console.error("Get Estimate Counts Error:", error);
    }
    // finally {
    //   setCountLoading(false);
    // }
  };

  const fetchEstimates = async (status = 0) => {
    try {
      setEstimateLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}customers/GetCustomerEstimates/${id}?Status=${status}`,
      );
      const data = await response.json();

      if (data?.Status) {
        setEstimates(data.ResultData || []);
      } else {
        setEstimates([]);
      }
    } catch (error) {
      console.error("Get Estimates Error:", error);
      setEstimates([]);
    } finally {
      setEstimateLoading(false);
    }
  };

  const updateEstimatesStatus = async (estimateId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}estimates/UpdateEstimatesStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: estimateId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        fetchEstimates(0); // Reload your proposal list
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchEstimateCounts();
    fetchEstimates(0);
    getEstimatesStatuses();
  }, []);


  return (
    <div>
      <div className="row g-3">
        {/* Draft */}
        <div className="col-12 col-sm-6 col-xl d-flex">
          <div
            className={`card flex-fill shadow-sm ${
              selectedStatus === 1 ? "border-primary" : ""
            }`}
            onClick={() => {
              setSelectedStatus(1);
              fetchEstimates(1);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div  className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-0 fw-bold">
                  {estimateCounts.Draft || 0}/
                  {estimateCounts.TotalEstimates || 0}
                </h4>
                <p className="mb-0 fw-semibold">Draft</p>
              </div>

              <div
                className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-file-lines text-primary fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Sent */}
        <div className="col-12 col-sm-6 col-xl d-flex">
          <div
            className={`card flex-fill shadow-sm ${
              selectedStatus === 2 ? "border-primary" : ""
            }`}
            onClick={() => {
              setSelectedStatus(2);
              fetchEstimates(2);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div  className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-0 fw-bold">
                  {estimateCounts.Sent || 0}/
                  {estimateCounts.TotalEstimates || 0}
                </h4>
                <p className="mb-0 fw-semibold">Sent</p>
              </div>

              <div
                className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-paper-plane text-info fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Expired */}
        <div className="col-12 col-sm-6 col-xl d-flex">
          <div
            className={`card flex-fill shadow-sm ${
              selectedStatus === 3 ? "border-primary" : ""
            }`}
            onClick={() => {
              setSelectedStatus(3);
              fetchEstimates(3);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div  className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-1 fw-bold">
                  {estimateCounts.Expired || 0}/
                  {estimateCounts.TotalEstimates || 0}
                </h4>
                <p className="mb-0 fw-semibold">Expired</p>
              </div>

              <div
                className="rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-hourglass-end text-warning fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Declined */}
        <div className="col-12 col-sm-6 col-xl d-flex">
          <div
            className={`card flex-fill shadow-sm ${
              selectedStatus === 4 ? "border-primary" : ""
            }`}
            onClick={() => {
              setSelectedStatus(4);
              fetchEstimates(4);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div  className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-1 fw-bold">
                  {estimateCounts.Declined || 0}/
                  {estimateCounts.TotalEstimates || 0}
                </h4>
                <p className="mb-0 fw-semibold">Declined</p>
              </div>

              <div
                className="rounded-circle bg-danger bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-circle-xmark text-danger fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Accepted */}
        <div className="col-12 col-sm-6 col-xl d-flex">
          <div
            className={`card flex-fill shadow-sm ${
              selectedStatus === 5 ? "border-primary" : ""
            }`}
            onClick={() => {
              setSelectedStatus(5);
              fetchEstimates(5);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div  className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-0 fw-bold">
                  {estimateCounts.Accepted || 0}/
                  {estimateCounts.TotalEstimates || 0}
                </h4>
                <p className="mb-0 fw-semibold">Accepted</p>
              </div>

              <div
                className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-circle-check text-success fs-4"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card table-list-card ">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <div className="search-set">
      
          </div>
          <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
            <div className="me-3">
              {/* <Select
                defaultValue="2026"
                style={{ width: 120, height: 34 }}
                options={[
                  { value: "2026", label: "2026" },
                  { value: "2025", label: "2025" },
                  { value: "2024", label: "2024" },
                ]}
              /> */}
            </div>

            <div className="page-btn">
              <Link
                to="/crm/add/estimate"
                className="btn btn-success btn-sm me-2"
                state={{
                  type: "customer",
                  customerId: customerData.customerId,
                  record: customerData,
                }}
              >
                <i className="ti ti-circle-plus fs-4 "> </i>
              </Link>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            {estimateLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "250px", // adjust height if needed
                }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <Table columns={columns} dataSource={estimates} />
            )}
          </div>
        </div>
      </div>

      <CommonFooter />
    </div>
  );
};

export default EstimatesTab;
